export class UserData {
  static LAST_UNIT_ID = "lastUnitId";

  static inMemoryStore = {};

  static set(key, value) {
    this.inMemoryStore[key] = value;
    this._save();
  }
  static get(key, defaultValue) {
    const inMemoryValue = this.inMemoryStore[key];
    if (inMemoryValue) {
      return inMemoryValue;
    }

    this._load();
    return this.inMemoryStore[key] ?? defaultValue;
  }

  static _load() {
    this.inMemoryStore = JSON.parse(localStorage.getItem("UserData") ?? "{}");
  }

  static _save() {
    localStorage.setItem("UserData", JSON.stringify(UserData.inMemoryStore));
  }
}
